import * as React from 'react';
export const IcRupeeCoinOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.74 5.68l1-1a1.005 1.005 0 00-.71-1.714 1.004 1.004 0 00-.71.294l-16 16a.999.999 0 000 1.42 1.001 1.001 0 001.42 0l1-1c.1.08.19.18.3.26H6a9.9 9.9 0 006 2 10.001 10.001 0 007.74-16.26zM16 12h-1.14a4 4 0 01-2.61 2.78l2.26 1.36a1 1 0 01-1.02 1.72l-3.71-2.23L15.41 10H16a1 1 0 110 2zm-8.2 0a1.006 1.006 0 01.2-2h1.76l1-1H8a1 1 0 010-2h4.76l3.86-3.86A10 10 0 003.14 16.62L7.8 12z'
      fill='currentColor'
    />
  </svg>
);
